import {
  ChangeDetectorRef,
  Component,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { AuctionService } from '../../_services/auction/auction.service';
import { Auction } from '../../_interfaces/auction.interface';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { BuyerAuthService } from 'src/app/app-modules/buyer/buyer-core/buyer-authentication/services/buyer-auth/buyer-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

import {
  changeAuctionsStatuses,
  getAuctionsData,
} from 'src/app/_utlis/auctions-helpers';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { IPagination } from 'src/app/Shared/_models/pagination.model';
import {
  CardsPerPage,
  getPaginationData,
  ItemsPerPage,
} from 'src/app/_utlis/pagination-helper';
import { PageHeaderComponent } from '../../../../../../Shared/components/page-header/page-header.component';
import { BuyerPageOptionsComponent } from '../../../../buyer-shared/components/buyer-page-options/buyer-page-options.component';
import { SearchInputComponent } from '../../../../../../Shared/components/search/search-input.component';
import { PaginationResultsComponent } from '../../../../../../Shared/components/pagination-results/pagination-results.component';
import { ReactiveFormsModule } from '@angular/forms';

import { BuyerAuctionCardComponent } from '../../../../buyer-shared/components/buyer-auction-card/buyer-auction-card.component';
import { NoDataComponent } from '../../../../../../Shared/components/no-data/no-data.component';
import { PaginationComponent } from '../../../../../../Shared/components/pagination/pagination.component';
import { isPlatformBrowser } from '@angular/common';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { TermsAndConditionsAcceptanceService } from 'src/app/app-modules/buyer/buyer-shared/services/terms-and-conditions-acceptance.service';
import { getAuctionChannels } from '../../_PusherEvents/auction-pusher-events';
import * as Events from 'src/app/_contstants/pusher-contstants';
import {
  IAuctionUpdateEventPayload,
  IBuyerApplicationStatusPayload,
  ITermsAndConditionsPayload,
} from 'src/app/Shared/_models/pusher-events-payload.model';
import { RolloverRefreshCoordinator } from '../../../../buyer-shared/utils/rollover-refresh-coordinator';

@Component({
    selector: 'app-buyer-active-auctions',
        standalone: true,
templateUrl: './buyer-active-auctions.component.html',
    styleUrls: ['./buyer-active-auctions.component.scss'],
    imports: [
    PageHeaderComponent,
    BuyerPageOptionsComponent,
    SearchInputComponent,
    PaginationResultsComponent,
    ReactiveFormsModule,
    BuyerAuctionCardComponent,
    NoDataComponent,
    PaginationComponent,
    TranslatePipe
]
})
export class BuyerActiveAuctionsComponent {
  isLoading!: boolean;
  auctionType = 'active';
  searchVal = '';
  auctions: any[] = [];
  loggedIn = false;
  breadcrumbs: Breadcrumb[] = [];
  currentLang: any;
  timer!: any;

  user_id!: number;
  page: number = 1;
  itemsPerPage: number = CardsPerPage;

  paginationData!: {
    totalPages: number;
    total: number | undefined;
    from: number | undefined;
    to: number | undefined;
  };
  calledFirstTime!: boolean;
  isBrowser: boolean;

  private subscriptions = new Subscription();
  private rolloverRefreshCoordinator = new RolloverRefreshCoordinator(2000);
  constructor(
    private auctionService: AuctionService,
    private toastService: ToastService,
    private auth: BuyerAuthService,
    private router: Router,
    private pusherService: PusherService,
    private titleService: Title,
    private translate: TranslateService,
    private storage: StorageService,
    private route: ActivatedRoute,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private termsAcceptance: TermsAndConditionsAcceptanceService,
    private cdr: ChangeDetectorRef
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      this.currentLang = JSON.parse(
        localStorage.getItem(this.storage.getPrefixedKey('selectedLang')) ?? '{}'
      );
    }
  }
  ngOnInit(): void {
    this.initializeMetaTags();

    this.initializeAuthSubscription();
    if (this.isBrowser) {
      this.subscribeToAcceptedTerms();
    }
    this.initializeRouteSubscription();
  }

  initializeMetaTags() {
    this.titleService.setTitle(
      'Active Auctions | Discover Horses Up for Bid Now '
    );
    this.meta.addTag({
      name: 'description',
      content:
        'Explore our current horse auctions and find your perfect equine companion. Browse available horses and place your bid today.',
    });
  }

  initializeAuthSubscription() {
    const authSub = this.auth.loggedIn_authorized$.subscribe((res) => {
      this.loggedIn = res;
      if (this.calledFirstTime) {
        this.getAuctions();
      }
      this.unSubscribeFromChannels();
      this.user_id = this.storage?.userData?.id;
      this.subscribeToChannels();
    });

    this.subscriptions.add(authSub);
  }

  initializeRouteSubscription() {
    const routeSub = this.route.queryParams.subscribe((params) => {
      this.page = +params['page'];
      this.searchVal = params['search'] || '';
      this.getAuctions();
    });
    this.subscriptions.add(routeSub);
  }
  resetSearch() {
    this.router.navigate(['/buyer/auctions/active']);
  }
  getAuctions(load = true) {
    this.calledFirstTime = true;
    let serverTime = 0;
    const interval = setInterval(() => {
      serverTime++;
    }, 1000);
    this.toastService.clear();
    if (load) {
      this.isLoading = true;
    }
    this.auctionService
      .getActiveAuctions(this.searchVal, this.page || 1, this.itemsPerPage)
      .subscribe({
        next: (response: {
          data: { items: Auction[]; pagination: IPagination };
          current_datetime: Date;
        }) => {
          this.auctions = getAuctionsData(response, serverTime);
          clearInterval(interval);

          this.paginationData = getPaginationData(
            response.data.pagination,
            this.itemsPerPage
          );
        },
        error: (error) => {
          clearInterval(interval);
          this.toastService.showError(error?.error?.Error[0]);
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  handleActions(e: { action: string; data: Auction }) {
    const { action, data } = e;
    const queryParams = {
      auctionTypePage: 'active',
    };
    switch (action) {
      case 'place':
        this.router.navigate(['/buyer/auctions', data.slug], {
          queryParams,
        });

        break;
      case 'time_ended':
        this.scheduleRolloverFallback(data?.id);

        break;

      case 'load_data':
        this.getAuctions();

        break;
    }
  }

  handleSearch(search: string) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      const queryParams: any = { search };

      this.router.navigate(['/buyer/auctions/active'], { queryParams });
    }, 1500);
  }
  onPageChanged(page: number): void {
    const queryParams: any = { page };
    if (this.searchVal) {
      queryParams.search = this.searchVal;
    }

    this.router.navigate(['/buyer/auctions/active'], {
      queryParams,
    });
  }

  cardClicked(e: any, item: any) {
    e.stopPropagation();

    const queryParams = {
      auctionTypePage: 'active',
    };
    this.router.navigate(['/buyer/auctions', item.slug], { queryParams });
  }

  subscribeToAcceptedTerms() {
    const termsSub = this.termsAcceptance.buyerAccepted$.subscribe((value) => {
      if (value?.isAccepted === 'accepted') {
        this.auctions.forEach((element: any) => {
          if (element?.id === value?.auctionId) {
            element.buyer_accepted_seller_terms = value?.isAccepted;
          }
        });
        this.cdr.detectChanges();
      }
    });

    this.subscriptions.add(termsSub);
  }

  subscribeToChannels() {
    const channels = getAuctionChannels(this.user_id);
    this.pusherService.subscribeToMultiChannels(channels, (data: any) => {
      this.handlePusherEvents(data);
    });
  }

  handlePusherEvents(eventData: { eventName: string; data: any }) {
    const { eventName, data } = eventData;
    switch (eventName) {
      case Events.TERMS_CONDITIONS_UPDATE:
        this.handleTermsAndConditionUpdatedEvent(data);
        break;

      case Events.BUYER_APP_ACCEPTED:
        this.handleBuyerAppEvent(data, true);
        break;

      case Events.BUYER_APP_REJECTED:
        this.handleBuyerAppEvent(data, false);
        break;

      case Events.AUCTION_UPDATED:
        this.handleAuctionUpdate(data);
        break;
    }
  }

  handleTermsAndConditionUpdatedEvent(data: ITermsAndConditionsPayload) {
    if (data?.affected_auctions) {
      data?.affected_auctions.forEach((element: number) => {
        const matchedAuction = this.auctions.find(
          (auc: any) => auc.id === element
        );

        if (matchedAuction) {
          matchedAuction.seller_terms = data?.terms_and_conditions;
          matchedAuction.buyer_accepted_seller_terms = 'not accepted';
        }
      });
    }
  }

  handleBuyerAppEvent(data: IBuyerApplicationStatusPayload, accepted: boolean) {
    if (data.auction_ids) {
      this.auctions = [
        ...changeAuctionsStatuses(data.auction_ids, accepted, this.auctions),
      ];
    }
    if (accepted) {
      this.getAuctions(false);
    }
  }

  handleAuctionUpdate(data: IAuctionUpdateEventPayload) {
    const auctionIn = this.auctions.findIndex(
      (el) => el?.id == data?.auction_id
    );

    if (data?.status?.active) {
      if (auctionIn !== -1) {
        this.rolloverRefreshCoordinator.cancelFallbackOnRealtimeUpdate(
          data?.auction_id
        );
        this.auctions[auctionIn] = {
          ...this.auctions[auctionIn],
          highest_bid_amount: data.highest_bid_amount_not_winning_items,
          highest_bid_amount_not_winning_items:
            data.highest_bid_amount_not_winning_items,
          extended_end_date: data.end_time,
          current_date: data.current_datetime,
          gradual_ending_settings: data?.gradual_ending_settings,
        };
      } else {
        this.rolloverRefreshCoordinator.cancelFallbackOnRealtimeUpdate(
          data?.auction_id
        );
        this.getAuctions(false);
      }
    }
  }

  private scheduleRolloverFallback(auctionId?: number): void {
    this.rolloverRefreshCoordinator.scheduleFallbackRefresh(
      () => this.getAuctions(false),
      auctionId
    );
  }

  unSubscribeFromChannels() {
    const channels = getAuctionChannels(this.user_id).map(
      (el) => el.channelName
    );

    if (channels.length) {
      this.pusherService.unsubscribeFromChannels(channels);
    }
  }
  ngOnDestroy(): void {
    this.rolloverRefreshCoordinator.dispose();
    this.subscriptions.unsubscribe();
    this.unSubscribeFromChannels();

    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
